<template>
    <section>
        <TextInput 
            :label="email.label"
            :placeholder="email.label"
            :importedData="email.value"
            @update:value="email.value = $event"
            class="mbottom-m"
            :valid="email.valid"
            :validationMessage="email.validationMessage"
        />

        <TextInput 
            :label="password.label"
            :placeholder="password.label"
            :importedData="password.value"
            @update:value="password.value = $event"
            class="mbottom-m"
            :valid="password.valid"
            :validationMessage="password.validationMessage"
        />
        
        <SelectInput 
            :label="role.label"
            :placeholder="role.label"
            :options="roles"
            :importedData="role.value"
            @update:value="role.value = $event"
            class="mbottom-m"
            :valid="role.valid"
            :validationMessage="role.validationMessage"
        />
        
        <TextInput 
            :label="lname.label"
            :placeholder="lname.label"
            :importedData="lname.value"
            @update:value="lname.value = $event"
            class="mbottom-m"
            :valid="lname.valid"
            :validationMessage="lname.validationMessage"
        />

        <TextInput 
            :label="fname.label"
            :placeholder="fname.label"
            :importedData="fname.value"
            @update:value="fname.value = $event"
            class="mbottom-m"
            :valid="fname.valid"
            :validationMessage="fname.validationMessage"
        />
        
        <TextInput 
            :label="pname.label"
            :placeholder="pname.label"
            :importedData="pname.value"
            @update:value="pname.value = $event"
            class="mbottom-m"
        />

        <TextInput 
            :label="phone.label"
            :placeholder="phone.label"
            :importedData="phone.value"
            @update:value="phone.value = $event"
            class="mbottom-m"
        />

        <textarea 
            rows="7" 
            v-model="about.value"
            style="width: 100%; padding: 10px; box-sizing: border-box; font-size: .8rem"
            class="mbottom-l"
            placeholder="Описание"
        ></textarea>      
        
        <GZ-BaseButton
            :value="$route.params.id ? 'изменить данные' : 'добавить сотрудника'"
            class="gz-button gz-button_default" 
            icon="icon-hipster"
            :loading="loading"
            @click="$route.params.id ? editStaffMember($route.params.id) : addStaffMember()"
        />
    </section>
</template>

<script>
import TextInput from '@/components/ui/jg_forms/text-input/TextInput'
import SelectInput from '@/components/ui/jg_forms/select-input/SelectInput'

const generator = require('generate-password')

export default {
    name: 'AddStaffForm',

    components: {
        TextInput,
        SelectInput
    },
    data() {
        return {
            email: {
                label: 'Email',
                value: '',
                valid: true,
                validationMessage: ''
            },
            password: {
                label: 'Пароль',
                value: '',
                valid: true,
                validationMessage: ''
            },
            role: {
                label: 'Роль',
                value: {},
                valid: true,
                validationMessage: ''
            },
            lname: {
                label: 'Фамилия',
                value: '',
                valid: true,
                validationMessage: ''
            },
            fname: {
                label: 'Имя',
                value: '',
                valid: true,
                validationMessage: ''
            },
            pname: {
                label: 'Отчество',
                value: '',
                valid: true,
                validationMessage: ''
            },
            phone: {
                label: 'Телефон',
                value: '',
                valid: true,
                validationMessage: ''
            },
            about: {
                label: 'Описание',
                value: '',
                valid: true,
                validationMessage: ''
            },
            avatar: {
                label: 'Фото профиля',
                value: [],
                valid: true,
                validationMessage: ''
            },
            profileId: '',
            uid: '',

            loading: false,

            roles: this.$store.getters['filtersRoles']
        }
    },
    mounted() {
        if (!this.$route.params.id) {
            this.password.value = generator.generate({
                length: 10,
                numbers: true
            });
        }

        if (this.$route.params.id) {
            //Если редактирование
            this.$store.dispatch('staffUserviewGet', this.$route.params.id)
                .then(() => {
                    this.profileId = this.$store.getters['staffUserview'].attributes.profid                    
                    const staffUser = this.$store.getters['staffUserview'].attributes

                    this.email.value = staffUser.email
                    this.lname.value = staffUser.lname
                    this.fname.value = staffUser.fname
                    this.pname.value = staffUser.pname
                    this.phone.value = staffUser.phone
                    this.about.value = staffUser.about
                    this.uid = this.$store.getters['staffUserview'].id

                    staffUser.role.forEach(role => {
                        this.roles.forEach(item => {
                            if (role === item.value) this.role.value = item
                        })
                    })

                    
                })
        }
    },
    methods: {
        validation() {
            const message = this.$store.getters['validationMessages']

            let errors = 0
            //Empty fields
            //** Email */
            //Не пустое
            if (!this.isEmpty(this.email.value)) {
                this.formValidationUtil(this.email, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.email, true, '')
                //Sintax
                if (!this.emailValidation(this.email.value)) {
                    this.formValidationUtil(this.email, false, message.uncorrectEmail)
                    errors++
                } else {
                    this.formValidationUtil(this.email, true, '')
                }
            }

            //** Password */
            //Не пустое
            if (!this.isEmpty(this.password.value)) {
                this.formValidationUtil(this.password, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.password, true, '')
            }

            //** Role */
            //Не пустое
            if (!this.isEmptyObject(this.role.value)) {
                this.formValidationUtil(this.role, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.role, true, '')
            }

            //** Lname */
            //Не пустое
            if (!this.isEmpty(this.lname.value)) {
                this.formValidationUtil(this.lname, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.lname, true, '')
            }

            //** Fname */
            //Не пустое
            if (!this.isEmpty(this.fname.value)) {
                this.formValidationUtil(this.fname, false, message.isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.fname, true, '')
            }

            //Notification
            return this.validationNotification(errors)
        },
        addStaffMember() {
            if (this.validation()) {
                this.$axios({
                    method: 'POST',
                    url: 'signup',
                    data: {
                        data: {
                            type: 'user',
                            attributes: {
                                email: this.email.value,
                                password: this.password.value
                            }
                        }
                    }
                })
                .then(response => { 
                    const id = response.data.data.id
                    
                    let arr = []
                    arr.push(this.role.value.value)

                    this.$axios({
                        method: 'PATCH',
                        url: 'user/' + id,
                        data: {
                            roles: arr
                        }
                    })
                    .catch(err => {
                        console.error('Ошибка добавления роли для пользователя: ', err)
                    })

                    return response
                })
                .then(response => {

                    const id = response.data.data.id

                    this.$axios({
                        method: 'POST',
                        url: 'profiles',
                        data: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    uid: id,
                                    fname: this.fname.value,
                                    lname: this.lname.value,
                                    pname: this.pname.value,
                                    email: this.email.value,
                                    phone: this.phone.value,
                                    about: this.about.value
                                }
                            }
                        }
                    })
                    .catch(err => {
                        console.error('Ошибка добавления данных в профиль: ', err.response)
                    })

                    return response
                })
                .then(response => {
                    this.$store.dispatch('staffIsAdded')
                    this.$store.dispatch('modalNotificationMessageOpen', ['Сотрудник добавлен'])
                    this.$store.dispatch('modalClose')
                    location.reload()
                })
                .catch(err => {
                    console.error('Ошибка добавления сотрудника: ', err)
                })
            }
        },
        editStaffMember() {
            let arr = []
            arr.push(this.role.value.value)

            if (this.validation()) {
                this.$axios({
                    method: 'PATCH',
                    url: 'user/' + this.uid,
                    data: {
                        password: this.password.value,
                        roles: arr
                    }
                })
                .then(() => {
                    this.$axios({
                        method: 'PATCH',
                        url: 'profiles/' + this.profileId,
                        data: {
                            data: {
                                type: 'profile',
                                id: this.profileId,
                                attributes: {
                                    uid: this.uid,
                                    fname: this.fname.value,
                                    lname: this.lname.value,
                                    pname: this.pname.value,
                                    email: this.email.value,
                                    phone: this.phone.value,
                                    about: this.about.value
                                }
                            }
                        }
                    }, this.loading = true)
                    .then(({data}) => {
                        this.$store.dispatch('modalNotificationMessageOpen', ['Информация изменена'])
                        this.loading = false                    
                    })
                    .catch(err => {
                        console.error('Ошибка добавления данных в профиль: ', err.response)
                        this.loading = false                    
                    })
                })
            }
        }
    },
    watch: {
        $route() {
            //Если редактирование
            this.$store.dispatch('staffUserviewGet', this.$route.params.id)
                .then(() => {
                    this.profileId = this.$store.getters['staffUserview'].attributes.profid

                    const staffUser = this.$store.getters['staffUserview'].attributes
                    this.email.value = staffUser.email
                    this.lname.value = staffUser.lname
                    this.fname.value = staffUser.fname
                    this.pname.value = staffUser.pname
                    this.phone.value = staffUser.phone
                    this.about.value = staffUser.about
                    this.uid = this.$store.getters['staffUserview'].id
                })
        }
    }
}
</script>